import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface UseCollaborationProps {
  id: string;
  enabled?: boolean;
  onSuccess?: (res: ResponseObject | Api.Influencer.Collaboration) => void;
}

export function useCollaboration({ id, enabled = true, onSuccess }: UseCollaborationProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: `influencer-collaboration-${id}`,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/collaboration/${id}`,
        token
      }).then((response: Api.Influencer.Collaboration | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        if (onSuccess) {
          onSuccess(response);
        }

        return response;
      }),
    enabled: !!token && enabled
  });

  return {
    data: data as Api.Influencer.Collaboration,
    isLoading,
    error,
    refetch
  };
}
